export function canSeeItem(roleActions, allowedActions) {
  if (!allowedActions) return true;
  if (roleActions.includes('*')) return true;
  let canSee = false;
  for (const action of roleActions) {
    canSee = allowedActions.includes(action);
    if (canSee) break;
  }
  return canSee;
}